export const examSubmitEmail = (userName, participantName) => {
  return `
<div>
Dear ${userName},
<br/>
<p>We hope this email finds you well.
<br/>
<b>Thank you</b> for choosing the Practido - Olympiad Practice App to support your child's academic journey. understand the importance of nurturing young minds and are delighted to be a part of your child's educationexperience.</p>

<p>We are excited to share the results of the recent tests your child, <b>${participantName}</b> took on Practido - Olympiad Practice App. Attached to this email, you will find a PDF document containing detailed answeto the questions from the test. This comprehensive report aims to provide insights into your child's performanchelping you understand their strengths and areas where they can further enhance their skills.</p>
Thanks & Regards<br/>
<b>Team ${process.env.REACT_APP_NAME}</b>
</div>
      `;
};
